import React, { useState, forwardRef, useImperativeHandle, useRef, useEffect } from 'react'
import { connect } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { Form, Typography, Modal, Button, Space } from 'antd'
import { InfoCircleOutlined } from '@ant-design/icons'
import { RegisterWrapper, AddPsBtn } from './style'

import { AddOperation } from '../../../../common/operation'
import { AddPsModal } from '../../../../common/modal'

import { addUserPsRole, isExistPmuOrPs } from '../../../../request/api'
import AddPsInfo from '../psInfo/index'
import moment from 'moment'
import service from '../../../../request'
import Tour from '../../../tour/index'
import PmuForm from '../pmuForm'

const RegisterPsInfo = forwardRef((props, ref) => {
    useImperativeHandle(ref, () => ({
        handleOpen,
    }));

    const { t } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);
    const [okTextStr, setOkTextStr] = useState(t('All.Operation.submit'));
    const [registerPsForm] = Form.useForm();
    const isErrState = useRef(0);
    const [textInfo, setTextInfo] = useState({
        paramsOne: '',
        paramsTwo: '',
        paramsThree: '',
    });
    const typeButton = useRef('');
    const [loading, setLoading] = useState(false);
    const [disabling, setDisabling] = useState(true);
    const [nextNum, setNextNum] = useState(-1);
    const [addIndex, setAddIndex] = useState(0);
    const [sunLoad, setSunLoad] = useState(true);
    const [subPsInfo, setSubPsInfo] = useState(0);
    const [pmuSn, setPmuSn] = useState('');

    const [status, setStatus] = useState(false);

    const firstForm = useRef(null);
    const secondForm = useRef(null);
    useEffect(() => {
        //openRegister();
        // document.body.style.overflow = 'hidden'

        if (props.psList.length === 0) {
            start();
        }
    }, [props.psList]);

    useEffect(() => {
        if (addIndex === 2) {
            setOkTextStr(t('All.Operation.submit'));
        } else {
            setOkTextStr(t('All.Operation.next'));
        }
    }, [addIndex]);

    const start = () => {
        setStatus(true);
    };

    const onSetStatus = (data) => {
        setStatus(data);
    };

    //点击引导添加弹出绑定电站功能
    const handleBackAction = value => {
        switch (value) {
            case 'next':
                break;
            case 'skip':
                showModal();

                break;
            default:
                break;
        }
    };

    const handleCancel = () => {
        setIsOpen(false);
        setNextNum(0);
        registerPsForm.resetFields();
        setDisabling(false);
        setTextInfo({
            paramsOne: '',
            paramsTwo: '',
            paramsThree: '',
        });
        setSunLoad(true);
        document.body.classList.remove('bodyCss');
    };

    const showModal = () => {
        //打开窗口初始化
        setAddIndex(0);
        isErrState.current = 0;
        setIsOpen(true);
        setDisabling(true);
        // setOkTextStr(t('All.Operation.submit'))
        setIsOpen(true);
        document.body.classList.add('bodyCss');
        firstForm.current?.resetForm(); //重置表单
        secondForm.current?.resetForm();
        setSubmintPmuInfo({
            addMode: '',
            pmuParent: { sn: '', attach_desc: '' },
            pmu: { sn: '', attach_desc: '' },
            //附加信息添加
        });
    };

    const handleOpen = () => {
        isErrState.current = 0;
        setIsOpen(true);
        setDisabling(true);
        // setOkTextStr(t('All.Operation.submit'))
        setIsOpen(true);
    };

    const handlePsVail = value => {
        if (!value) {
            setLoading(false);
        }
    };

    //验证采集器序列号添加还是电站id绑定
    const handleIsExistPmuOrPs = () => {
        //  setOkTextStr(t('All.Operation.submit'))
        setAddIndex(0);
        registerPsForm
            .validateFields()
            .then(values => {
                setDisabling(false);
                var params = { psIdSn: '', userId: '' };
                params['psIdSn'] = values.registerPsForm['psIdSn'];
                params['userId'] = props.userInfo['userId'];
                isExistPmuOrPs(params['psIdSn']).then(res => {

                    if (res.status === 200) {
                        isErrState.current = 200;
                        typeButton.current = res.data.type;
                        if (res.data.type !== undefined && res.data.type === 'pmuId') {
                            setTextInfo({
                                paramsOne: res.data.modelName,
                                paramsTwo: res.data.brandName,
                                paramsThree: res.data.payNum,
                            });
                            setOkTextStr(t('All.Operation.next'));
                        }
                        if (res.data.type !== undefined && res.data.type === 'psId') {
                            setTextInfo({
                                paramsOne: res.data.psName,
                                paramsTwo: res.data.psTypeName,
                                paramsThree: moment(res.data.psBuilddate).format('YYYY-MM-DD'),
                            });
                            setOkTextStr(t('All.Operation.submit'));
                        }
                    }
                });
            })
            .catch(err => {
                setDisabling(true);
                console.info('login err', err);
            });
    };

    const handleOk = () => {
        //提交采集器注册
        if (typeButton.current === 'pmuId' && okTextStr === t('All.Operation.submit')) {
            setSubPsInfo(Math.floor(Math.random() * 999999));
            setLoading(true);
            return;
        }
        var params = { pmuSn: '', userId: '' };

        params['userId'] = props.userInfo['userId'];
        if (typeButton.current === 'psId') {
            params['pmuSn'] = submitPsInfo['psId'];
            setLoading(true);
            addUserPsRole(params).then(res => {
                switch (res.status) {
                    case 200: //根据电站ID添加关系
                        window.location.reload(); // 绑定成功刷新页面
                        break;
                    default:
                        //setIsErrState(res.status)
                        break;
                }
            });
        }

        if (typeButton.current === 'pmuId') {
            console.log('采集器序列号', submitPmuInfo);
            if (okTextStr === t('All.Operation.next')) {
                //next
                //   setOkTextStr(t('All.Operation.submit'));//submit
                setNextNum(Math.floor(Math.random() * 999999));
                setAddIndex(addIndex + 1); // 下一步
            }
        }
    };

    //电站id添加的信息
    const [submitPsInfo, setSubmintPsInfo] = useState({
        psId: '',
    });

    //采集器主序列号添加的信息
    const [submitPmuInfo, setSubmintPmuInfo] = useState({
        addMode: '',
        pmuParent: { sn: '', attach_desc: '' },
        pmu: { sn: '', attach_desc: '' },
        //附加信息添加
    });


    //第一次输入框的值
    const [firstValue, setFirstValue] = useState({
        addType: '', //验证通过后的类型
        idOrSn: '', //电站ID或采集器序列号
        attachDesc: '', //附加信息
        mode: 1,
    });

    //集群模式采集器输入框的值
    const [secondValue, setSecondValue] = useState({
        addType: '', //验证通过后的类型
        idOrSn: '', //电站ID或采集器序列号
        attachDesc: '', //附加信息
        mode: 1,
    });

    //第一次验证事件
    const validateFirst = async value => {
        if (value.addType === '') {
            //验证失败
            setDisabling(true);
            setFirstValue({ addType: '', idOrSn: '', attachDesc: '', mode: 1 });
        } else {
            setDisabling(false);
            if (value.addType === 'pmuId' && value.idOrSn !== '') {
                setFirstValue(value);
            } else if (value.addType === 'psId' && value.idOrSn !== '') {
                setFirstValue(value);
            }
        }
    };

    //集群模式采集器验证事件
    const validateSecond = async value => {
        setSecondValue({ addType: '', idOrSn: '', attachDesc: '', mode: 1 });
        if (value.addType === '') {
            //验证失败
            setDisabling(true);
        } else {
            setSecondValue(value);
            setDisabling(false);
        }
    };

    //上一步
    const handleBack = () => {
        setDisabling(false);
        if (firstValue.mode === 2 || firstValue.addType === 'psId') {
            setAddIndex(addIndex - 2);
        } else {
            setSecondValue({ addType: '', idOrSn: '', attachDesc: '', mode: 1 });
            setAddIndex(addIndex - 1);

        }

        setNextNum(0);
        setSunLoad(false);
        //  setOkTextStr(t('All.Operation.next'))
    };

    //下一步
    const handleNext = () => {

        //firstForm.current?.validateSerialId();&& firstForm.current?.serialIdValid
        if (addIndex === 0) {
            //第一步验证失败
            firstForm.current?.validateForm().then(values => {
                //验证通过
                console.log('验证通过:', firstValue);
                //设置添加模式 1.单机模式 2.集群模式
                setSubmintPmuInfo({ ...submitPmuInfo, addMode: firstValue.mode, pmuParent: { sn: firstValue.idOrSn, attach_desc: firstValue.attachDesc } });

                if (firstValue.addType === 'psId') {
                    //根据电站ID添加关系
                    setAddIndex(addIndex + 2);
                } else if (firstValue.mode === 2) {
                    //单机模式
                    setAddIndex(addIndex + 2);
                } else {
                    //集群模式
                    setAddIndex(addIndex + 1);
                    secondForm.current?.resetForm();
                }
                setDisabling(true);
            })
                .catch(err => {
                    console.log('表单验证错误:', err);
                });

            setNextNum(0);
            setSunLoad(false);
        } else if (addIndex === 1) {
            secondForm.current?.validateForm().then(values => {
                setSubmintPmuInfo({ ...submitPmuInfo, pmu: { sn: secondValue.idOrSn, attach_desc: secondValue.attachDesc } });

                setAddIndex(addIndex + 1);
            }).catch(err => {
                console.log('表单验证错误:', err);
            });
        }

        //  setOkTextStr(t('All.Operation.next'))
    };

    //提交事件
    const handelOk = async () => {
        //电站Id 创建绑定事件
        if (firstValue.addType === 'psId') {
            var params = { pmuSn: '', userId: '' };
            params['userId'] = props.userInfo['userId'];
            params['pmuSn'] = firstValue['idOrSn'];
            setLoading(true);
            addUserPsRole(params).then(res => {
                switch (res.status) {
                    case 200: //根据电站ID添加关系
                        window.sessionStorage.setItem('psId', firstValue['idOrSn']); //电站添加成功，默认选中电站
                        window.location.reload(); // 绑定成功刷新页面
                        break;
                    default:
                        //setIsErrState(res.status)
                        break;
                }
            });
        } else if (firstValue.addType === 'pmuId') {
            setSubPsInfo(Math.floor(Math.random() * 999999));
            setLoading(true);
            return;
        } else if (firstValue.addType === 'pmuId' && okTextStr === t('All.Operation.next')) {
            //判断单机模式还是集群模式
            if (firstValue.mode === 1) {
                //集群模式
                setAddIndex(addIndex + 1); // 下一步
            } else {
                setAddIndex(addIndex + 2); // 下一步
            }
        }
        //判断是否集群模式
    };

    return (
        <>
            <AddPsBtn>
                <AddOperation btnText={t('All.Operation.Add.addPlant')} type='addPlant' onClick={showModal} />
            </AddPsBtn>
                <AddPsModal
                  className='ModalDefault ModalAddPs DividerCenterSM'
                  isOpen={isOpen}
                  handleCancel={handleCancel}
                  handleBack={handleBack}
                  handleNext={handleNext}
                  handelOk={handelOk}
                  addIndex={addIndex}
                  disabling={disabling}
                  loading={loading}
                  firstValue={firstValue}
                >
                {/* 添加主采集器 nextNum=0*/}
                <RegisterWrapper className={addIndex === 0 ? 'isShow' : 'isHide'}>
                    <Space direction='vertical' size={16}>
                        <Typography.Text>
                            <Space direction='vertical' size={0}>
                                <Typography.Text>
                                    <Space size={4}>
                                        <InfoCircleOutlined />
                                        {t('All.Note.Tips.addViaSerialNumberOrPlantID')}
                                    </Space>
                                </Typography.Text>
                                <Typography.Text type='secondary'>
                                    {t('All.Note.Tips.loggerSerialNumber')}
                                    <span className='number-style-important'>15</span>
                                    {t('All.Note.Tips.characters')}
                                    <span className='slash-style'>/</span>
                                    {t('All.Note.Tips.plantID')}
                                    <span className='number-style-important'>12</span>
                                    {t('All.Note.Tips.characters')}
                                </Typography.Text>
                            </Space>
                        </Typography.Text>
                        <PmuForm onValidate={validateFirst} present={secondValue} ref={firstForm} mode={true} />
                    </Space>
                </RegisterWrapper>
                {/* 添加备用采集器 nextNum=1*/}
                <RegisterWrapper className={addIndex === 1 ? 'isShow' : 'isHide'}>
                    <Space direction='vertical' size={16}>
                        <Typography.Text>
                            <Space direction='vertical' size={0}>
                                <Typography.Text>
                                    <Space size={4}>
                                        <InfoCircleOutlined />
                                        {t('All.Note.Tips.addStandbyLogger')}
                                    </Space>
                                </Typography.Text>
                            </Space>
                        </Typography.Text>
                        <PmuForm onValidate={validateSecond} present={firstValue} ref={secondForm} mode={false} />
                    </Space>
                </RegisterWrapper>
                {/* 添加电站信息  nextNum=2*/}
                <AddPsInfo randomNum={addIndex} submitPmuInfo={submitPmuInfo} randomSubPs={subPsInfo} vailPsClick={handlePsVail} pmuSnSet={pmuSn} sunLoadSet={sunLoad} cancelSet={handleCancel} />
            </AddPsModal>
            <Tour run={status} onSetStatus={onSetStatus} handleBack={handleBackAction} />
        </>
    );
});

const mapStateToProps = state => {
    return {
        psList: state.getIn(['header', 'psinfoList', 'list']),
        userInfo: state.getIn(['header', 'userinfoList', 'user']),
    };
};

const mapDippathToProps = dispatch => {
    return {
        handleLoad() { },
    };
};

export default connect(mapStateToProps, mapDippathToProps, null, { forwardRef: true })(RegisterPsInfo);